module.exports = __webpack_public_path__ + "static/media/A4 - 5.f3cae5af.png";